import { API_ORGANIZATION_PREFIX } from '@shared/config/api/api-prefixes';
import { organizationBaseApi } from './base';
import {
    OrganizationDetailDataRequest,
    OrganizationDetailDataResponse,
    OrganizationPreviewDataRequest,
    OrganizationPreviewDataResponse,
    OrganizationSuggestionDataRequest,
    OrganizationSuggestionDataResponse,
    OrganizationsListDataRequest,
    OrganizationsListDataResponse,
} from './organization-types';
import { queryParametersToString } from '@shared/lib/utils/query-parameters-to-string/query-parameters-to-string';
import { isEqualParameters } from '@shared/lib/utils/is-equal-parameters/is-equal-parameters';

export const organizationApi = organizationBaseApi.injectEndpoints({
    endpoints: (build) => ({
        organizationsList: build.query<OrganizationsListDataResponse, OrganizationsListDataRequest>({
            query: ({ take, search, skip }) =>
                `${API_ORGANIZATION_PREFIX}${queryParametersToString({ take, search, skip })}`,
            providesTags: ['OrganizationsList'],
        }),
        organizationsInfinityList: build.query<OrganizationsListDataResponse, OrganizationsListDataRequest>({
            query: (parameters) => `${API_ORGANIZATION_PREFIX}${queryParametersToString({ ...parameters })}`,
            serializeQueryArgs: (params) => {
                return `${params.endpointName}_${params.queryArgs.search}`;
            },
            merge: (currentCache, newItems) => {
                if (newItems.skip) {
                    currentCache.items.push(...newItems.items);
                }
            },
            forceRefetch({ currentArg, previousArg }) {
                return !isEqualParameters({ currentParameters: currentArg, previousParameters: previousArg });
            },
        }),
        organizationDetail: build.query<OrganizationDetailDataResponse, OrganizationDetailDataRequest>({
            query: (id) => `${API_ORGANIZATION_PREFIX}/${id}/detail`,
            providesTags: ['OrganizationDetail'],
        }),
        organizationPreview: build.query<OrganizationPreviewDataResponse, OrganizationPreviewDataRequest>({
            query: (id) => `${API_ORGANIZATION_PREFIX}/${id}/preview`,
        }),
        currentOrganizationPreview: build.query<OrganizationPreviewDataResponse, OrganizationPreviewDataRequest>({
            query: (id) => `${API_ORGANIZATION_PREFIX}/${id}/preview`,
            // 1 day
            keepUnusedDataFor: 60 * 60 * 24,
            providesTags: ['CurrentOrganization'],
        }),
        organizationSuggestion: build.query<OrganizationSuggestionDataResponse, OrganizationSuggestionDataRequest>({
            query: (search) => `${API_ORGANIZATION_PREFIX}/dadata/${queryParametersToString({ search })}`,
        }),
    }),
});

export const {
    useLazyOrganizationsListQuery,
    useOrganizationsInfinityListQuery,
    useLazyOrganizationDetailQuery,
    useLazyOrganizationSuggestionQuery,
    useLazyCurrentOrganizationPreviewQuery,
    usePrefetch: usePrefetchOrganization,
} = organizationApi;
